Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.default = setTimeout.bind(globalThis);